import { Button, ButtonGroup, Grid, Switch } from '@material-ui/core';
import { useMemo, useState } from 'react';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import { ToggleButton } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';
import ReactDOM from 'react-dom';
import BreakTest from '../workflow-job/BreakTest';
import DialogComp from '../../../Core/Modal/dialogModal';

const baseColumns = [
    // { title: 'Action', field: 'action', width: 80, filterable: false },
    { field: 'reg', sortable: true, title: 'Registration', width: 110 },
    { field: 'wipNumber', sortable: true, title: 'WIP Number', width: 140 },
    { field: 'cust', sortable: true, title: 'Customer' },
    { field: 'bn', sortable: true, title: 'Branch' },
    { field: 'dateUploaded', sortable: true, title: 'Date Uploaded' },
    { field: 'uploadedBy', sortable: true, title: 'Uploaded By' }
];

const crumbs = () => {
    let list = [
        { name: 'Home', path: '/' },
        { name: 'Reports', active: true },
        { name: 'Brake Tests', active: true }
    ];
    return list;
};

// const useStyles = makeStyles((theme) => ({
//     columnStyle: {
//         cursor: 'pointer'
//     }
// }));

const BrakeTestList = (props) => {
    const history = useHistory();
    // const classes = useStyles();

    const [state, setState] = useState({ BrakeTestSigned: false });

    const handleAddCust = (record) => {
        setState((st) => ({ ...st, showLoanVehicleUsage: true, selectedRecord: record }));
    };

    const closeLoanVehicleUsageModal = (record) => {
        setState((st) => ({ ...st, showLoanVehicleUsage: false, selectedRecord: {} }));
    };

    const registrationLVUHandler = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid onClick={() => handleAddCust(record)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                {record.reg}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const redirectToScreens = (record) => {
        history.push(`/Job/${record.headerID}/${record.workflowID}?ProcessId=${record.processID}`);
    };

    const wipLVUHandler = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid onClick={() => redirectToScreens(record)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                {record.wipNumber}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...baseColumns];

        let registrationCol = col.find((m) => m.field === 'reg');
        if (registrationCol) {
            registrationCol.renderer = registrationLVUHandler;
        }

        let actionCol = col.find((m) => m.field === 'wipNumber');
        if (actionCol) {
            actionCol.renderer = wipLVUHandler;
        }

        return col;
    }, []);

    const getUrl = `BrakeTest/UnsignedBrakeTest_List?BrakeTestSigned=${state.BrakeTestSigned}`;

    return (
        <div className="report-screen-container">
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs>
                    <BreadCrumbs crumbs={crumbs()} />
                </Grid>
                {/* <Grid item>
                    Unsigned &nbsp;
                    <Switch
                        color="primary"
                        checked={state.BrakeTestSigned}
                        onChange={(e) => setState((st) => ({ ...st, BrakeTestSigned: e.target.checked }))}
                    />
                    &nbsp; Signed
                </Grid> */}
                <Grid component="label" item alignItems="center">
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        <Button
                            style={{ fontSize: 12 }}
                            variant={!state.BrakeTestSigned ? 'contained' : 'outlined'}
                            // onClick={() => handleFilter(true, 1)}
                            onClick={() => setState((st) => ({ ...st, BrakeTestSigned: false }))}
                        >
                            Unsigned
                        </Button>
                        <Button
                            style={{ fontSize: 12 }}
                            variant={state.BrakeTestSigned ? 'contained' : 'outlined'}
                            // onClick={() => handleFilter(false, 2)}
                            onClick={() => setState((st) => ({ ...st, BrakeTestSigned: true }))}
                        >
                            Signed
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ padding: '10px 0px' }}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res.data.list,
                            total: res.data.total
                        })}
                        columns={column}
                        getUrl={getUrl}
                        displayPagination={true}
                    />
                </Grid>
            </Grid>

            {state.showLoanVehicleUsage && (
                <DialogComp title={'Brake Test'} onClose={() => closeLoanVehicleUsageModal(false)} maxWidth="xl" fullScreen overflow>
                    <BreakTest HeaderRecordID={state.selectedRecord?.headerID || null} />
                </DialogComp>
            )}
        </div>
    );
};
export default BrakeTestList;
